import { NextPage } from "next"
import WorkWithUsForm from "../../components/forms/work-with-us-form"
import { devLog } from "../../utils"
import { Seo } from "../../components/seo"
import React from "react"
import { useTranslation } from "react-i18next"
import { Text, Title } from "../../components/typography"

const WorkWithUsPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <div className={"container my-16 mx-auto px-6"}>
      <Seo
        title={t("seo:workWithUs.title")}
        description={t("seo:workWithUs.description")}
      />
      <div className="text-center my-6">
        <Title>{t("label:workWithUsPageTitle")}</Title>
        <Text type="secondary">{t("label:workWithUsPageSubtitle")}</Text>
      </div>
      <WorkWithUsForm
        actionUrl="/api/v1/work-with-us"
        onFinish={values => {
          devLog({ values })
        }}
      />
    </div>
  )
}

export default WorkWithUsPage
